import { apiRequest } from './apiClient';

export async function getGradingSystem() {
  const response = await apiRequest('/student/grading-system');

  return response.data || null;
}
